import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../theme/theme';
import { initials, avatarGradient } from '../utils/format';

/** Small gradient avatar (initials), colour derived from the name. */
export const Avatar: React.FC<{ name: string; gradient?: string; size?: number }> = ({ name, gradient, size = 30 }) => (
  <Box
    sx={{
      width: size, height: size, borderRadius: '50%', flexShrink: 0,
      display: 'grid', placeItems: 'center', color: '#fff', fontWeight: 700,
      fontSize: size * 0.4, background: gradient || avatarGradient(name),
    }}
  >
    {initials(name)}
  </Box>
);

/** Avatar + primary name + optional subtext (id / caption). Mirrors .named. */
const NameCell: React.FC<{ name: string; sub?: string; mono?: boolean }> = ({ name, sub, mono }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
    <Avatar name={name} />
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ fontWeight: 600, fontSize: 13.5 }}>{name}</Typography>
      {sub && (
        <Typography sx={{ color: colors.textTertiary, fontSize: 12, fontFamily: mono ? 'ui-monospace, monospace' : undefined }}>
          {sub}
        </Typography>
      )}
    </Box>
  </Box>
);

export default NameCell;
